import { InvoiceModel } from '@app/core/models/invoices/invoice.model';

export class FaultedInvoiceModel extends InvoiceModel {

  public ExpectedState: string;
  public Type: FaultedInvoiceType;
  public DocumentId: number | null;
  public DocumentFileName: string | null;
}

export enum FaultedInvoiceType {
  WRONGSTATE = 1,
  STUCK = 2,
  CREATIONFAILURE = 3,
}
